export const NIGHTS_RESET_STATE = 'NIGHTS_RESET_STATE';
export const NIGHTS_SET_DATA_FROM_HOME_FORM = 'NIGHTS_SET_DATA_FROM_HOME_FORM';
export const NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS = 'NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS';
export const NIGHTS_SET_EXTRA_QUANTITY = 'NIGHTS_SET_EXTRA_QUANTITY';
export const NIGHTS_SET_HOTEL = 'NIGHTS_SET_HOTEL';
export const NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_STANDARD = 'NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_STANDARD';
export const NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_LUXURY = 'NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_LUXURY';
export const NIGHTS_SET_PACK_HOTELS = 'NIGHTS_SET_PACK_HOTELS';
export const NIGHTS_SET_ITINERARY = 'NIGHTS_SET_ITINERARY';
export const NIGHTS_SET_TOTAL_PRICE_PACK = 'NIGHTS_SET_TOTAL_PRICE_PACK';
export const NIGHTS_SET_SELECTED_CATEGORY = 'NIGHTS_SET_SELECTED_CATEGORY';
export const NIGHTS_SET_PASSENGER_DATA = 'NIGHTS_SET_PASSENGER_DATA';
export const NIGHTS_SET_PASSENGERS_ARRAY = 'NIGHTS_SET_PASSENGERS_ARRAY';
export const NIGHTS_SET_RESOURCES = 'NIGHTS_SET_RESOURCES';
export const NIGHTS_SET_STATE = 'NIGHTS_SET_STATE';
export const NIGHTS_SET_FLIGHT = 'NIGHTS_SET_FLIGHT';
export const NIGHTS_TOGGLE_EXTRA = 'NIGHTS_TOGGLE_EXTRA';
export const NIGHTS_TOGGLE_PASSENGER_BAG = 'NIGHTS_TOGGLE_PASSENGER_BAG';
export const SET_NIGHTS_DISCOUNT_CODE = 'SET_NIGHTS_DISCOUNT_CODE';
export const RESOURCES_BAGS_CALUCLATE = 'RESOURCES_BAGS_CALUCLATE';
export const SET_CONTACT_DATA = 'SET_CONTACT_DATA';
export const SET_CONTACT_PACK_AVM = 'SET_CONTACT_PACK_AVM';
export const SET_RESERVATION_ID = 'SET_RESERVATION_ID';
export const SET_INTERCONTINENTAL_FLIGHTS = 'SET_INTERCONTINENTAL_FLIGHTS';
export const NIGHTS_SET_LUXURY_EXTRA = 'NIGHTS_SET_LUXURY_EXTRA';
export const NIGHTS_SET_EXTRA_NO_PROMO_PRICE = 'NIGHTS_SET_EXTRA_NO_PROMO_PRICE';
export const NIGHTS_SET_PACK = 'NIGHTS_SET_PACK';
export const UPDATE_PACK_FLIGHT = 'UPDATE_PACK_FLIGHT';
export const SET_JOURNEY_FLIGHT = 'SET_JOURNEY_FLIGHT';
export const SET_RETURN_FLIGHT = 'SET_RETURN_FLIGHT';
export const SET_FLIGHT_SELECTOR = 'SET_FLIGHT_SELECTOR';
export const SET_DESTINATION_CARDS = 'SET_DESTINATION_CARDS';


